'use client'

import { useState } from 'react'

const LockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
)

const MESI = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre']

function formatDate(dateStr) {
  if (!dateStr) return '—'
  const [y, m, d] = dateStr.split('-')
  return `${parseInt(d)} ${MESI[parseInt(m) - 1]} ${y}`
}

export default function OrderPanel({
  selected, extraTypes = [], extrasMap = {}, onExtrasChange, spotCount,
  spotsTotal = 0, ivaRate = 0,
  selectedDate, onProceed, checkout = false, onBack, onPay, paying = false,
  linkedExtraIds = null,
}) {
  const [condizioni, setCondizioni] = useState(false)
  const [privacy, setPrivacy]       = useState(false)

  const BOOKING_FEE = 2
  const extrasTotal = extraTypes.reduce((sum, e) => sum + (extrasMap[e.id] || 0) * e.price, 0)
  const subtotal    = spotsTotal + extrasTotal
  const total       = subtotal + BOOKING_FEE
  const ivaAmount   = total * ivaRate / (1 + ivaRate)

  const fmt = (n) => n.toFixed(2).replace('.', ',') + '\u00a0€'

  return (
    <div className="order-panel">

      {/* Extra services — solo in modalità selezione posto */}
      {!checkout && extraTypes.length > 0 && (
        <div className="card extras-card">
          <div className="card-title">Servizi extra</div>
          {extraTypes.map(extra => {
            const qty = extrasMap[extra.id] || 0
            let maxQty
            if (linkedExtraIds?.has(extra.id)) {
              const otherId = [...linkedExtraIds].find(i => i !== extra.id)
              const otherQty = extrasMap[otherId] || 0
              maxQty = Math.min(extra.availableQuantity, 1 * spotCount - otherQty)
            } else {
              maxQty = Math.min(extra.availableQuantity, extra.maxQuantity * spotCount)
            }
            return (
              <div className="extra-item" key={extra.id}>
                <div className="qty-control">
                  <button className="qty-btn" onClick={() => onExtrasChange(extra.id, -1)} disabled={qty <= 0}>−</button>
                  <span className="qty-value">{qty}</span>
                  <button className="qty-btn" onClick={() => onExtrasChange(extra.id, 1)} disabled={qty >= maxQty || spotCount === 0}>+</button>
                </div>
                <span className="extra-label">{extra.name} ({extra.price}€)</span>
              </div>
            )
          })}
        </div>
      )}

      {/* Order summary */}
      <div className="summary-card">
        <div className="card-title">Riepilogo ordine</div>

        <div className="summary-row">
          <span className="sr-label">Data:</span>
          <span className="sr-price">{formatDate(selectedDate)}</span>
        </div>

        {spotCount > 0 ? (
          <div className="summary-row">
            <div>
              <div className="sr-label">Posti selezionati: {spotCount}</div>
              {Array.from(selected.values()).map((label, i) => (
                <div key={i} className="sr-detail">{label}</div>
              ))}
            </div>
            <span className="sr-price">{fmt(spotsTotal)}</span>
          </div>
        ) : (
          <div className="summary-row">
            <span className="sr-label sr-label--empty">Nessun posto selezionato</span>
          </div>
        )}

        {extraTypes.map(extra => {
          const qty = extrasMap[extra.id] || 0
          if (qty === 0) return null
          return (
            <div className="summary-row" key={extra.id}>
              <span className="sr-label">{extra.name}: {qty}</span>
              <span className="sr-price">{fmt(qty * extra.price)}</span>
            </div>
          )
        })}

        {subtotal > 0 && (
          <>
            <div className="summary-divider" />
            <div className="summary-row">
              <span className="sr-label">Costo prenotazione:</span>
              <span className="sr-price">{fmt(BOOKING_FEE)}</span>
            </div>
            <div className="summary-divider" />
            <div className="summary-total">
              <span>Totale:</span>
              <span>{fmt(total)}</span>
            </div>
            <div className="summary-iva-note">
              {checkout
                ? `di cui IVA ${Math.round(ivaRate * 100)}%: ${fmt(ivaAmount)}`
                : 'IVA inclusa'}
            </div>
          </>
        )}
      </div>

      {/* Payment */}
      {!checkout ? (
        <div className="payment-section">
          {spotCount > 0 && (
            <div className="secure-badge">
              <LockIcon />
              <span>PAGAMENTO SICURO</span>
            </div>
          )}
          <button className="pay-btn" disabled={spotCount === 0} onClick={onProceed}>
            PROCEDI AL PAGAMENTO
          </button>
        </div>
      ) : (
        <div className="payment-section">
          <label className="checkout-checkbox-row">
            <input type="checkbox" className="form-checkbox" checked={condizioni} onChange={e => setCondizioni(e.target.checked)} />
            <span className="form-checkbox-label">Accetto <a href="/policy#condizioni" target="_blank" rel="noopener noreferrer" className="checkout-link">Condizioni di prenotazione</a></span>
          </label>
          <label className="checkout-checkbox-row">
            <input type="checkbox" className="form-checkbox" checked={privacy} onChange={e => setPrivacy(e.target.checked)} />
            <span className="form-checkbox-label">Accetto <a href="/policy#privacy" target="_blank" rel="noopener noreferrer" className="checkout-link">Privacy policy</a></span>
          </label>
          <div className="secure-badge">
            <LockIcon />
            <span>PAGAMENTO SICURO</span>
          </div>
          <button className="pay-btn" disabled={paying || !condizioni || !privacy || spotCount === 0} onClick={onPay}>
            {paying ? 'INVIO...' : 'PAGA ORA'}
          </button>
          <button className="back-btn" style={{ alignSelf: 'center', marginTop: 4 }} onClick={onBack}>
            ← Torna indietro
          </button>
        </div>
      )}

    </div>
  )
}
